/**
 * CheckoutOverlay styles — CWR 2.6.
 *
 * The post-confirm overlay — S5 (confirming) + S6 (slow confirm). Ported from the
 * payment-page mockup `.overlay` / `.ov-icon` onto injected client tokens. The
 * success green (#5BC08C / 91,192,140) is a sanctioned SEMANTIC literal — a fixed
 * success indicator, not a per-tenant brand color (the mockup pins it as `--ok`;
 * there is no injected success token). The slow state uses the themed accent.
 */

.overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(var(--bg-page-rgb), 0.9);
  backdrop-filter: blur(8px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 40px;
  animation: overlayFadeIn 0.3s ease-out;
}

.icon {
  width: 76px;
  height: 76px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  margin-bottom: 22px;
  background: rgba(91, 192, 140, 0.16);
  border: 1.5px solid rgba(91, 192, 140, 0.5);
  color: #5bc08c;
  box-shadow: 0 0 36px rgba(91, 192, 140, 0.3);
  animation: overlayScaleIn 0.4s var(--ease-bounce, cubic-bezier(0.34, 1.56, 0.64, 1));
}

.icon svg {
  width: 38px;
  height: 38px;
}

/* S6 slow: the charge SUCCEEDED — amber clock-spinner, not a failure tone. */
.iconSlow {
  background: rgba(var(--accent-rgb), 0.16);
  border-color: rgba(var(--accent-rgb), 0.5);
  color: var(--accent-hot);
  box-shadow: 0 0 36px rgba(var(--accent-rgb), 0.28);
  animation: none;
}

.spin {
  animation: overlaySpin 1.1s linear infinite;
  transform-origin: center;
}

.title {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 26px;
  color: var(--text-primary);
}

.amount {
  margin-top: 7px;
  font-family: var(--font-body);
  font-size: 14px;
  font-weight: 600;
  color: var(--text-secondary);
}

.redir {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-top: 18px;
  font-size: 13px;
  color: var(--text-tertiary);
  line-height: 1.5;
}

.redir svg {
  width: 15px;
  height: 15px;
}

/* S6 reassurance line has no icon — block layout, narrower. */
.redirSlow {
  display: block;
  max-width: 260px;
  text-align: center;
}

.done {
  margin-top: 26px;
  min-height: 48px;
  padding: 12px 40px;
  border-radius: 14px;
  background: var(--glass-bg-strong);
  border: 1px solid var(--border-soft);
  color: var(--text-primary);
  font-family: var(--font-body);
  font-size: 14px;
  font-weight: 600;
}

@keyframes overlayFadeIn {
  from {
    opacity: 0;
  }
}

@keyframes overlayScaleIn {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  60% {
    transform: scale(1.1);
  }
}

@keyframes overlaySpin {
  to {
    transform: rotate(360deg);
  }
}
